import React from "react";
import "./ModernLoader.css";

const ModernLoader = () => {
  return (
    <div className="modern-loader">
      <div className="loader-container">
        <div className="loader-circle">
          <div className="loader-inner"></div>
        </div>
        <div className="loader-text">Loading...</div>
        <div className="loader-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default ModernLoader;
